import { render, staticRenderFns } from "./CollectionPointPage.vue?vue&type=template&id=26f2d52e&scoped=true"
import script from "./CollectionPointPage.vue?vue&type=script&lang=js"
export * from "./CollectionPointPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointPage.vue?vue&type=style&index=0&id=26f2d52e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2d52e",
  null
  
)

export default component.exports